module.exports = __webpack_public_path__ + "img/M1_BK_12.f9c0ff48.png";